module.exports = __webpack_public_path__ + "static/ETCH_STARS-ae94092c8343877a0c68a00d5867eb0c.gif";